import { Component, OnInit, ViewChild, ElementRef, inject, model, } from '@angular/core';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent, MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { BookService } from 'src/app/services/book.service';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Observable, startWith, map, debounceTime } from 'rxjs';

@Component({
  selector: 'kbm-genre-chips',
  templateUrl: './genre-chips.component.html',
  styleUrls: ['./genre-chips.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatOptionModule,
    AsyncPipe,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class GenreChipsComponent implements OnInit {
  @ViewChild('auto') matAutocomplete!: MatAutocomplete;
  @ViewChild('genreInput') genreInput!: ElementRef<HTMLInputElement>;

  genres = model.required<string[]>();

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;

  separatorKeysCodes = [
    ENTER, COMMA
  ];

  genreCtrl = new UntypedFormControl();

  allGenres: string[] = [];

  filteredGenres!: Observable<string[]>;

  bookService = inject(BookService);

  ngOnInit(): void {
    this.loadGenres();
    this.filteredGenres = this.genreCtrl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        map((value: any) => this._filter(value || '')),
      );
  }

  async loadGenres() {
    try {
      const genreList = await this.bookService.getGenreList();
      this.allGenres = genreList.map(g => g)
    }
    catch (err) {
      console.error(err);
    }
  }

  add(evt: MatChipInputEvent): void {
    const value = (evt.value || '').trim();
    // Add our genre
    if (value) {
      this.genres().push(value);
    }
    // Clear input value
    evt.chipInput!.clear();
    this.genreInput.nativeElement.value = '';
    this.genreCtrl.setValue(null);
  }

  remove(genre: string): void {
    const index = this.genres().indexOf(genre);

    if (index >= 0) {
      this.genres().splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.genres) {
      this.genres().push(event.option.viewValue);
    } else {
      console.log('Huh, no genres to start');
    }
    this.genreInput.nativeElement.value = '';
    this.genreCtrl.setValue(null);
  }

  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();
    return this.allGenres.filter(
      (entry) => entry.toLowerCase().includes(filterValue)
    );
  }
}
